/* eslint-disable react/prop-types */
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Separator, Stack } from '@fluentui/react';
import React, { useContext } from 'react';
import { timeZones } from '@bingads-webui/timezone-details';
import { DisclaimerBanner } from '@bingads-webui-campaign-react/help';
import { getUserIdFromScopeSelector } from '../helpers/account-selector-helper';
import { ReportsV4SummaryBarWithOnlyName } from './summary-bar';
import { getStyles } from '../style';
import { UserScopeInput } from './account-selector/user-scope-input';


export function PreviewPageImplForUserScopeFilterLevel({
  onApplyClick,
  reportParam,
}) {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);

  return (
    <div className="user-filter-level-impl">
      <ReportsV4SummaryBarWithOnlyName />
      <Stack className={`header ${classes.reportPreviewHeader}`} horizontal horizontalAlign="space-between">
        <Stack.Item>
          <div className="name">
            {reportParam && reportParam.reportName}
          </div>
        </Stack.Item >
      </Stack >
      <Separator />
      <div className="body">
        <section className="help-info">
          <strong className="subtitle">
            {i18n.getString(_TL_('Please enter a user ID to continue'))}
          </strong>
          <div>
            {i18n.getString(_TL_('What it is: The ID Microsoft Advertising associates with the different users that can view or edit the campaign'))}
          </div>
        </section>
        <Separator />
        <UserScopeInput
          className="user-filter-level-input"
          userId={getUserIdFromScopeSelector(reportParam.scopeSelector)}
          onApplyClick={onApplyClick}
          isSeparatorBeforeButtons
          applyText={i18n.getString(_TL_('Apply and Run'))}
        />
        {reportParam && <DisclaimerBanner timezone={timeZones[reportParam.timeZone]} />}
      </div>
    </div>
  );
}
